function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './Logo.jss';
import { Link } from 'react-router';
var Logo = function Logo(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    disabledLogo = _ref.disabledLogo,
    filled = _ref.filled,
    isMenuOpen = _ref.isMenuOpen,
    logo = _ref.logo,
    logoForTransparentBackground = _ref.logoForTransparentBackground,
    logoUrl = _ref.logoUrl,
    logoUrlExternal = _ref.logoUrlExternal,
    mobileTransparent = _ref.mobileTransparent,
    onClick = _ref.onClick;
  var Logo = !isMenuOpen && mobileTransparent && !filled && logoForTransparentBackground ? logoForTransparentBackground : logo;
  /* eslint-disable no-nested-ternary */

  var LogoComponent = disabledLogo ? 'span' : logoUrlExternal ? 'a' : Link;
  var LogoProps = disabledLogo ? {} : logoUrlExternal ? {
    href: logoUrl
  } : {
    to: logoUrl
  };
  /* eslint-enable no-nested-ternary */

  return React.createElement(LogoComponent, _extends({
    onClick: onClick,
    className: classnames(classes.logo, className)
  }, LogoProps), React.createElement(Logo, null));
};
Logo.styleRoot = 'Logo';
export default injectStyles(styles)(Logo);